import classNames from 'classnames';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import { RenderHTML } from '../../../../../ReactComponents/RenderHTML';
import { CircleInfoColorVariant } from './CircleInfoColorVariant.csharp';
import { CircleInfoViewModel } from './CircleInfoViewModel.csharp';

export const CircleInfo = ({ model: { text, plainText, backgroundColor, link } }: { model: CircleInfoViewModel }) => {
    const largeFontLengthLimit = 60;
    const mediumFontLengthLimit = 196;
    const [paddingTop, setPaddingTop] = useState(0);
    const textWrapperRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLDivElement>(null);

    const textClassNames = classNames(
        'CircleInfo__Text',
        plainText?.length <= mediumFontLengthLimit && 'CircleInfo__Text--Medium',
        plainText?.length <= largeFontLengthLimit && 'CircleInfo__Text--Large'
    );

    useEffect(() => {
        calculatePadding();
        setTimeout(calculatePadding);
    }, [textWrapperRef.current, textRef.current, textRef.current?.clientHeight]);

    useEffect(() => {
        window.addEventListener('resize', calculatePadding);

        return () => {
            window.removeEventListener('resize', calculatePadding);
        };
    });

    const calculatePadding = () => {
        if (textWrapperRef.current && textRef.current) {
            const wrapperHeight = textWrapperRef.current.clientHeight;
            const textHeight = textRef.current.clientHeight - paddingTop;
            const padding = (wrapperHeight - textHeight) / 2;
            setPaddingTop(padding);
        }
    };

    const content = (
        <div className="CircleInfo__Circle">
            <div className="CircleInfo__TextWrapper" ref={textWrapperRef}>
                {text && <RenderHTML style={{ paddingTop }} ref={textRef} html={text} className={textClassNames} />}
            </div>
        </div>
    );

    return (
        <div className={classNames('CircleInfo', `CircleInfo--${CircleInfoColorVariant[backgroundColor]}`)}>
            {link ? (
                <a href={link} className="CircleInfo__Link">
                    {content}
                </a>
            ) : (
                content
            )}
        </div>
    );
};
